export type EventHandler = (params?: any) => void;

export default class EventRegistry {
  private registry: Map<string, Map<string, EventHandler>> = new Map();

  /**
   * Registers an event handler. Overwrites if the ownerId already exists for that event.
   */
  registerEvent(ownerId: string, event: string, func: EventHandler): boolean {
    if (!this.registry.has(event)) {
      this.registry.set(event, new Map());
    }
    const eventMap = this.registry.get(event)!;
    eventMap.set(ownerId, func);
    return true;
  }

  /**
   * Calls all handlers registered to a specific event.
   */
  raiseEvent(event: string, params?: any): void {
    const eventMap = this.registry.get(event);
    if (!eventMap) return;

    for (const handler of Array.from(eventMap.values())) {
      handler(params);
    }
  }

  /**
   * Unregisters a handler for a specific event and owner.
   * If event is not set, unregisters the owner from all events.
   */
  unregisterEvent(ownerId: string, event?: string): boolean {
    if (!event) {
      let removed = false;
      for (const [evt, eventMap] of Array.from(this.registry.entries())) {
        if (eventMap.delete(ownerId)) {
          removed = true;
          if (eventMap.size === 0) {
            this.registry.delete(evt);
          }
        }
      }
      return removed;
    }
    const eventMap = this.registry.get(event);
    if (!eventMap) return false;

    const deleted = eventMap.delete(ownerId);
    if (eventMap.size === 0) {
      this.registry.delete(event);
    }
    return deleted;
  }
}
